// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Col, Row, SchemaForm } from "@components";

type Props = $Exact<{
  data: ?Object,
  schema: Object | null,
  onRef: (ref: *) => *,
  onChange?: (data: Object) => void,
  onSubmit?: (data: Object) => void,
  ...PropsFromLocalize,
}>;

export class EmailNotificationDistributionRulesForm extends React.Component<Props> {
  form: *;

  get uiSchema() {
    return {
      "ui:order": ["emailDistributionType", "*"],
      id: { "ui:widget": "hidden" },
      name: { "ui:widget": "hidden" },
      isActive: { "ui:widget": "hidden" },
      includeEmployeePhoneNumber: { "ui:widget": "hidden" },
      includeWorkingHours: { "ui:widget": "hidden" },
      includeBradfordScore: { "ui:widget": "hidden" },
      includeJobTitle: { "ui:widget": "hidden" },
      includeAbsenceId: { "ui:widget": "hidden" },
      includeAbsenceReason: { "ui:widget": "hidden" },
      includeLastThreeAbsences: { "ui:widget": "hidden" },
      includeDepartmentParent: { "ui:widget": "hidden" },
      includeEmployeeRef: {
        "ui:widget": "hidden",
        "ui:options": {
          labels: [
            { label: this.props.t("ENABLE"), value: true },
            { label: this.props.t("DISABLE"), value: false },
          ],
        },
      },
      includePosition: { "ui:widget": "hidden" },
      startInstruction: { "ui:widget": "hidden" },
      updateNotification: { "ui:widget": "hidden" },
      closedInstruction: { "ui:widget": "hidden" },
      overdueInstruction: { "ui:widget": "hidden" },
      reasonSpecificInstructions: { "ui:widget": "hidden" },
      startNotifications: {
        "ui:widget": "hidden",
        "ui:options": {
          labels: [
            { label: this.props.t("ENABLE"), value: true },
            { label: this.props.t("DISABLE"), value: false },
          ],
        },
      },
      includeRtwDetailsInAbsenceNotifications: {
        "ui:widget": "toggle",
        "ui:options": { label: this.props.t("INCLUDE_RTW_DETAILS") },
      },
      includeAlertsInAbsenceNotifications: {
        "ui:widget": "toggle",
        "ui:options": { label: this.props.t("INCLUDE_ALERTS") },
      },
      emailDistributionType: { "ui:widget": "hidden" },
    };
  }

  render() {
    return (
      <SchemaForm
        ref={this.formRef}
        className="w-100"
        formData={this.props.data}
        schema={this.props.schema}
        uiSchema={this.uiSchema}
        onChange={this.props.onChange}
        onSubmit={this.props.onSubmit}
        externalSubmit
      />
    );
  }
}

export default localize()(EmailNotificationDistributionRulesForm);
